"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { SortDirection } from "@/entities/ISort";
import type { XtdhCollectionsOrder, XtdhCollectionsSortField } from "@/hooks/useXtdhCollectionsQuery";
import { DEFAULT_COLLECTION_SORT_DIRECTION, DEFAULT_COLLECTION_SORT_FIELD, parseCollectionSortDirection, parseCollectionSortField } from "../constants";
const SORT_PARAM = "xtdh_received_sort";
const DIRECTION_PARAM = "xtdh_received_dir";
interface XtdhCollectionsFiltersResult {
  readonly activeSortField: XtdhCollectionsSortField;
  readonly activeSortDirection: SortDirection;
  readonly apiOrder: XtdhCollectionsOrder;
  readonly handleSortChange: (sort: XtdhCollectionsSortField) => void;
}
export function useXtdhCollectionsFilters() {
  const $ = _c(17);
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t0;
  if ($[0] !== searchParams) {
    t0 = parseCollectionSortField(searchParams?.get(SORT_PARAM) ?? null);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeSortField = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = parseCollectionSortDirection(searchParams?.get(DIRECTION_PARAM) ?? null);
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const activeSortDirection = t1;
  const apiOrder = activeSortDirection === SortDirection.ASC ? "ASC" : "DESC";
  let t2;
  if ($[4] !== pathname || $[5] !== router || $[6] !== searchParams) {
    t2 = (sort, direction) => {
      if (!pathname) {
        return;
      }
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      if (sort === DEFAULT_COLLECTION_SORT_FIELD) {
        params.delete(SORT_PARAM);
      } else {
        params.set(SORT_PARAM, sort);
      }
      if (direction === DEFAULT_COLLECTION_SORT_DIRECTION) {
        params.delete(DIRECTION_PARAM);
      } else {
        params.set(DIRECTION_PARAM, direction.toLowerCase());
      }
      const query = params.toString();
      router.replace(query ? `${pathname}?${query}` : pathname, {
        scroll: false
      });
    };
    $[4] = pathname;
    $[5] = router;
    $[6] = searchParams;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const updateQueryParams = t2;
  let t3;
  if ($[8] !== activeSortDirection || $[9] !== activeSortField || $[10] !== updateQueryParams) {
    t3 = sort_0 => {
      const toggledDirection = activeSortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
      const nextDirection = sort_0 === activeSortField ? toggledDirection : DEFAULT_COLLECTION_SORT_DIRECTION;
      updateQueryParams(sort_0, nextDirection);
    };
    $[8] = activeSortDirection;
    $[9] = activeSortField;
    $[10] = updateQueryParams;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleSortChange = t3;
  let t4;
  if ($[12] !== activeSortDirection || $[13] !== activeSortField || $[14] !== apiOrder || $[15] !== handleSortChange) {
    t4 = {
      activeSortField,
      activeSortDirection,
      apiOrder,
      handleSortChange
    };
    $[12] = activeSortDirection;
    $[13] = activeSortField;
    $[14] = apiOrder;
    $[15] = handleSortChange;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}